import { Injectable } from '@angular/core';
import { Client, StompSubscription } from '@stomp/stompjs';
import { environment } from 'src/environments/environment';
import { Action, Notification } from '../../features/account/profile/types/notification';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  public client: Client;
  private publicSubscription: StompSubscription;
  private notificationSubscription: StompSubscription;
  public receiver: Subject<Notification> = new Subject();
  public actionReceiver: Subject<Action> = new Subject();

  constructor() {}

  connect(token: string, sessionId: string) {
    if (!sessionId) {
      return;
    }
    if (this.client && this.client.active) {
      this.client.deactivate();
    }
    this.client = new Client({
      brokerURL: environment.socketBaseUrl,
      connectHeaders: {
        Authorization: token,
        session: sessionId,
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });
    this.client.onConnect = (frame) => {
      this.publicSubscription = this.client.subscribe('/sub/public', (data) => {
        const notification = JSON.parse(data.body);
        this.receiver.next(notification);
      });

      this.notificationSubscription = this.client.subscribe(`/sub/notification/${sessionId}`, (data) => {
        const notification = JSON.parse(data.body);
        this.receiver.next(notification);
      });
      this.notificationSubscription = this.client.subscribe(`/sub/action/${sessionId}`, (data) => {
        const payload: Action = JSON.parse(data.body);
        this.actionReceiver.next(payload);
      });
    };

    this.client.onStompError = (frame) => {
      console.error(frame);
    };
    this.client.activate();
  }

  disconnect() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
    if (this.publicSubscription) {
      this.publicSubscription.unsubscribe();
    }
    if (this.client && this.client.active) {
      this.client.deactivate();
    }
  }
}
